import { render, staticRenderFns } from "./tutor.vue?vue&type=template&id=9df1e616&"
import script from "./tutor.vue?vue&type=script&lang=js&"
export * from "./tutor.vue?vue&type=script&lang=js&"
import style0 from "./tutor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tutor.vue"
export default component.exports